const HOURS_IN_MINUTEST = 60

export const prepareDuration = (duration?: number) => {
  if (!duration) {
    return {
      hours: 0,
      common: 0,
      minutes: 0,
    }
  }

  return {
    common: duration,
    minutes: duration % HOURS_IN_MINUTEST,
    hours: Math.floor(duration / HOURS_IN_MINUTEST),
  }
}
